module.exports = __webpack_public_path__ + "static/media/BLewisResume.b6243b63.pdf";